import React from "react";
import { Link } from "react-router-dom";
import mediaWall from "../../assets/media-wall.webp";
import materials from "../../assets/materials.webp";
import Icon from "../UI/Icon";

const points = [
  {
    icon: "compass",
    title: "Design-led builds",
    text: "We sketch, measure and plan every detail so the finished carpentry fits perfectly and feels intentional.",
  },
  {
    icon: "quote",
    title: "Clear, honest pricing",
    text: "Upfront written quotes with realistic timelines, so you know exactly what’s happening and when.",
  },
  {
    icon: "shield",
    title: "Trusted & insured",
    text: "Fully insured and tidy on site, treating your home with the same care as the finished piece.",
  },
];

export default function WhyUs() {
  return (
    <section className="bg-ink text-paper relative overflow-hidden">
      <div className="grain relative max-w-site mx-auto px-5 sm:px-10 py-16 md:py-24 lg:grid lg:grid-cols-2 lg:gap-16 items-center">
        {/* Images */}
        <div className="relative mb-12 lg:mb-0">
          <div className="overflow-hidden border border-white/10">
            <img src={mediaWall} alt="Bespoke media wall with slatted oak panelling, fitted alcove units and lit shelving by Cambridge Carpenter" className="w-full h-[420px] object-cover object-center" loading="lazy" />
          </div>
          <div className="absolute -bottom-8 -right-2 sm:right-6 w-44 sm:w-56 overflow-hidden border-4 border-ink shadow-xl hidden sm:block">
            <img src={materials} alt="Timber and materials" className="w-full h-40 object-cover" loading="lazy" />
          </div>
          <div className="absolute top-6 -left-3 bg-oak text-paper px-6 py-4 shadow-lg">
            <span className="block font-display text-3xl font-semibold leading-none">10+</span>
            <span className="text-xs uppercase tracking-wide text-paper/80">years’ experience</span>
          </div>
        </div>

        {/* Copy */}
        <div>
          <p className="eyebrow eyebrow--light mb-4">Why choose us</p>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
            Quality craftsmanship, start to finish
          </h2>
          <p className="text-paper/80 text-lg leading-8 mt-5">
            Every project is tailored to your home, whether it’s a single alcove unit or a full room
            refit. We combine thoughtful design with durable materials so your timberwork looks great
            and works hard for years.
          </p>
          <ul className="mt-8 space-y-6">
            {points.map((p) => (
              <li key={p.title} className="flex gap-4">
                <span className="shrink-0 w-11 h-11 flex items-center justify-center bg-white/5 border border-white/10 text-brass">
                  <Icon name={p.icon} className="w-6 h-6" />
                </span>
                <span>
                  <h3 className="block font-display font-semibold text-xl">{p.title}</h3>
                  <span className="block text-paper/75 leading-7 mt-1">{p.text}</span>
                </span>
              </li>
            ))}
          </ul>
          <Link to="/about-us" className="btn-outline-light mt-9">More about us</Link>
        </div>
      </div>
    </section>
  );
}
